{
  "docTasks": {
    "tabLabel": "Tasks",
    "title": "Tasks linked to this document",
    "count": "{{count}} task",
    "count_other": "{{count}} tasks",
    "createPlaceholder": "New task for this document...",
    "empty": "This document has no linked tasks.",
    "loadError": "Could not load the tasks.",
    "created": "Task created for this document",
    "createError": "Could not create the task",
    "untitled": "Untitled task",
    "markDone": "Mark as done",
    "markUndone": "Mark as pending",
    "open": "Open task"
  },
  "editor": {
    "placeholder": "Type here...",
    "saveButton": "save",
    "errors": {
      "tableLoadError": "Error loading table component",
      "addColumnError": "Error: {{error}}"
    }
  },
  "embed": {
    "database": {
      "copyUid": "Copy UID",
      "settings": "Settings",
      "searchPlaceholder": "Search...",
      "filters": "Filters",
      "schema": "Schema:",
      "table": "Table:",
      "previewPlaceholder": "Preview of table contents..."
    },
    "inlineFlow": {
      "loading": "Loading Inline Flow..."
    },
    "inlineOpsTable": {
      "loading": "Loading Operations Table..."
    }
  },
  "sidebar": {
    "searchPlaceholderActive": "Search...",
    "searchPlaceholderTrash": "Search in Trash...",
    "createNewDocument": "Create new document",
    "options": "Options",
    "addPage": "Add page",
    "newPageDefaultTitle": "New Page",
    "emptyTrash": "Trash is empty",
    "trash": "Trash",
    "backToDocs": "Back to Docs",
    "moveToTrash": "Move to Trash",
    "confirmBulkMoveToTrash": "Move these {{count}} documents and their subdocuments to trash?",
    "bulkMoveToTrashSuccess": "Moved to trash successfully.",
    "menu": {
      "permissionsSharing": "Permissions & Sharing",
      "lock": "Lock",
      "unlock": "Unlock",
      "moveToTrash": "Move to Trash",
      "restore": "Restore"
    },
    "confirmMoveToTrash": "Move to trash?",
    "errors": {
      "lockedCannotDelete": "This document is locked and cannot be deleted.",
      "deleteError": "Error deleting: {{message}}",
      "deleteFailed": "Error moving to trash.",
      "unknownError": "Unknown error"
    }
  },
  "comments": {
    "placeholder": "Write a comment...",
    "submit": "Comment",
    "cancel": "Cancel",
    "defaultAuthor": "User",
    "altAuthor": "Author",
    "altYou": "You",
    "altCommenter": "Commenter"
  },
  "versions": {
    "contentTab": "Content",
    "tabLabel": "Versions",
    "title": "Version history",
    "empty": "This document has no saved versions yet.",
    "loading": "Loading history...",
    "createButton": "Save version",
    "current": "Current version",
    "autosave": "Autosave",
    "manual": "Manual",
    "wordCount": "{{count}} words",
    "restore": "Restore this version",
    "restoreConfirm": "Restore the document to this version? A copy of the current state is saved before overwriting.",
    "restoreForbidden": "Only the document creator or a space admin can restore versions.",
    "restored": "Document restored.",
    "diffTruncated": "Differences truncated to the first {{count}} words.",
    "diffLegendAdded": "Added",
    "diffLegendRemoved": "Removed",
    "loadError": "Could not load the version history.",
    "modal": {
      "title": "Save a version",
      "nameLabel": "Version name",
      "namePlaceholder": "e.g. Before legal review",
      "save": "Save",
      "cancel": "Cancel",
      "saving": "Saving..."
    }
  }
}
